var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFragments = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.375 10.391V6.594a.47.47 0 0 0-.469-.469H14.11a2.35 2.35 0 0 0-2.296-1.875 2.35 2.35 0 0 0-2.297 1.875H5.72c-.26 0-.469.21-.469.469v3.75c0 .258.21.469.469.469a1.876 1.876 0 0 1 0 3.75c-.26 0-.469.21-.469.468v3.75c0 .259.21.469.469.469h3.75c.259 0 .469-.21.469-.469a1.876 1.876 0 0 1 3.75 0c0 .259.209.469.468.469h3.75c.26 0 .469-.21.469-.469v-3.797a2.35 2.35 0 0 0 1.875-2.296 2.35 2.35 0 0 0-1.875-2.297Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFragments);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fragments.41c2f9a1.svg";